export default function SuperAdminDashboard() {
    return (<></>)
}
